import { async_chatgpt } from "./async_chatgpt";
import { async_google_gemini } from "./async_google_gemini";
import { async_google_ai_mode } from "./async_google_ai_mode";
import { async_perplexity } from "./async_perplexity";


const aiResultsExamples: { [ index: string ]: { input: string, result: string } } = {
  async_chatgpt,
  async_google_gemini,
  async_google_ai_mode,
  async_perplexity,
};

export default aiResultsExamples;
